import { getOffer, TRAINING_OFFERS } from './trainingOffers';
import { getCataloguePath, getOfferPath } from './trainingRoutes';

const SITE_URL = 'https://csl-brands.com';

const getAbsoluteUrl = (path) => `${SITE_URL}${path}`;

const assertSupportedLocale = (locale) => {
  if (!getCataloguePath(locale)) {
    throw new TypeError(`Unsupported training locale: ${locale}`);
  }
};

export const buildCatalogueStructuredData = (locale) => {
  assertSupportedLocale(locale);

  return {
    '@type': 'ItemList',
    itemListElement: TRAINING_OFFERS.map((offer, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      url: getAbsoluteUrl(getOfferPath(locale, offer.key)),
    })),
  };
};

export const buildOfferStructuredData = (locale, offerKey, content) => {
  assertSupportedLocale(locale);

  const offer = getOffer(offerKey);
  if (!offer) {
    throw new TypeError(`Unsupported training offer: ${offerKey}`);
  }
  if (!content?.seo || !Array.isArray(content.faq)) {
    throw new TypeError('Unsupported training content');
  }

  const url = getAbsoluteUrl(getOfferPath(locale, offerKey));
  const courseId = `${url}#course`;

  return [
    {
      '@type': 'Course',
      '@id': courseId,
      url,
      name: content.seo.title,
      description: content.seo.description,
      hasCourseInstance: {
        '@type': 'CourseInstance',
        startDate: offer.intake,
        courseMode: locale === 'fr'
          ? ['Présentiel à Douala', 'En ligne']
          : ['In person in Douala', 'Online'],
      },
    },
    {
      '@type': 'Offer',
      '@id': `${url}#offer`,
      url,
      price: offer.total,
      priceCurrency: 'XAF',
      itemOffered: { '@id': courseId },
    },
    {
      '@type': 'FAQPage',
      '@id': `${url}#faq`,
      mainEntity: content.faq.map(({ question, answer }) => ({
        '@type': 'Question',
        name: question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: answer,
        },
      })),
    },
  ];
};
